const helpers = {
  share: function (platform, data) {
    var url;
    switch (platform) {
      case "facebook":
        url = "//www.facebook.com/sharer.php?u=" + encodeURIComponent(data); // App ID subject to change
        break;
      case "draugiem":
        data = JSON.parse(data);
        url =
          "//www.draugiem.lv/say/ext/add.php?title=" +
          encodeURIComponent(data.title) +
          "&link=" +
          encodeURIComponent(data.url) +
          "&text=" +
          encodeURIComponent(data.text);
        break;
      case "twitter":
        data = JSON.parse(data);
        // console.log(data);
        url =
          "//twitter.com/home?status=" +
          encodeURIComponent(data.title) +
          "+" +
          encodeURIComponent(data.url);
        break;

      case "linkedin":
        data = JSON.parse(data);
        // console.log(data);
        url =
          "//www.linkedin.com/shareArticle?mini=true&url=" +
          encodeURIComponent(data.url) +
          "&title=" +
          encodeURIComponent(data.title);
        break;
    }

    var myWindow = window.open(url, "", "width=600,height=313");
  },

  fb: function () {
    window.fbAsyncInit = function () {
      FB.init({
        appId: "1677177309186429",
        xfbml: true,
        version: "v2.2",
      });
    };
    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "//connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  },

  twttr: function () {
    window.twttr = (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0],
        t = window.twttr || {};
      if (d.getElementById(id)) return;
      js = d.createElement(s);
      js.id = id;
      js.src = "//platform.twitter.com/widgets.js";
      fjs.parentNode.insertBefore(js, fjs);

      t._e = [];
      t.ready = function (f) {
        t._e.push(f);
      };

      return t;
    })(document, "script", "twitter-wjs");
  },

  is_json_string: function (str) {
    try {
      var o = JSON.parse(str);
      if (o && typeof o === "object" && o !== null) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  },

  array_unique: function (arr) {
    var result = [];
    for (var i = 0; i < arr.length; i++) {
      if (result.indexOf(arr[i]) == -1) {
        result.push(arr[i]);
      }
    }
    return result;
  },

  is_valid_email: function (email) {
    var pattern = new RegExp(
      /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i
    );
    return pattern.test(email);
  },

  validate: function (form) {
    var error_msg = "";
    var errors = [];
    var coords_set = true;

    $.each(form.find(".required").not(".disabled"), function () {
      if ($(this).val() == "" || $(this).val() == "0") {
        $(this).addClass("error");
        errors.push(translations.required);
      }

      if ($(this).hasClass("type-email")) {
        if (!helpers.is_valid_email($(this).val())) {
          $(this).addClass("error");

          errors.push(translations.valid_email);
        }
      }
    });

    if (errors.length) {
      errors = helpers.array_unique(errors);
      errors.reverse();
      var output = '<div class="errors-wrap">';
      for (var i = errors.length - 1; i >= 0; i--) {
        output += errors[i] + "<br />";
      }
      output += "</div>";
      if ($(".errors-wrap").length) {
        $(".errors-wrap").remove();
      }
      form.prepend(output);
      $("html,body").animate(
        {
          scrollTop: $(".errors-wrap").offset().top - 150,
        },
        1000
      );
      return false;
    } else {
      return true;
    }
  },

  isElementInViewport(el) {
    var rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  },
};

export default helpers;
